import { useEffect, useState } from 'react';

export const useDebounce = (value: string, delay: number, onChange?: (value: string) => void): string => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
      if (onChange) {
        onChange(value);
      }
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay, onChange]);

  return debouncedValue;
};
